<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row v-if="listLoad">
      <v-col
        cols="12"
        md="4"
      >
        <v-skeleton-loader type="article"  class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>
      <v-col
        cols="12"
        md="8"
      >
        <v-row>
          <v-col cols="12" md="3">
            <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="3">
            <v-skeleton-loader type="card" width="200"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col> 
      <v-col
        cols="12"
      >
        <v-skeleton-loader type="card" class="d-block mr-4 mb-3"></v-skeleton-loader>
      </v-col>           
    </v-row>

    <v-row v-if="!listLoad">
      <v-col
        cols="12"
        md="6"
      >
        <v-container>
          <p class="mb-0">
            <span
              class="font-weight-medium"
              style="font-size: 20px"
            >
              {{ investorData.name }}
            </span>
          </p>
          <p class="mb-0">
            <span
              class="font-weight-medium"
              style="font-size: 15px"
            >
              {{ investorData.type }}
            </span>
          </p>          
          <v-row>
            <v-col cols="8">
              <p v-if="investorData.description" class="mb-0" style="font-size: 14px;">{{ investorData.description.substr(0, 100) }}...</p>
              <p v-else class="mb-0" style="font-size: 14px;">No description provided</p>
            </v-col>
            <v-col cols="4" class="text-right">
              <v-btn v-if="investorData.description" 
                text
                small
                @click="readmoreDialog = true"
                color="primary"
                class="mt-5"
              >
                Read more
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn v-if="investorData.list_funds && investorData.list_funds.length>0"
                small
                text
                color="primary"
                @click="fundlistDialog = true"
              >
                List of Funds
              </v-btn>
            </v-col>
            <v-col cols="8" class="text-right" style="font-size: 14px;">
              Last Updated: {{ formatDate(investorData.last_updated) }}
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-row>
          <!-- <v-col cols="12" md="3">
            <v-card height="150" :class="{'mr-3 card-width': $vuetify.breakpoint.mdAndUp}">
              <div class="d-block text-center pt-5">
                Predictibility
              </div>
              <div class="text-center">
                <radial-progress-bar
                  :diameter="80"
                  :strokeWidth="8"
                  :completed-steps="investorData.predictability * 100"
                  :total-steps="100"
                  startColor="#ee3b76"
                  stopColor="#ee3c47"
                  style="margin: 0 auto;"
                  class="my-3"
                >
                  <span style="color: #e9507f;">{{ investorData.predictability_label }}</span>
                </radial-progress-bar>
              </div>
            </v-card>
          </v-col> -->

          <v-col cols="12" md="4">
            <v-card height="150" :class="{'mr-3 card-width': $vuetify.breakpoint.mdAndUp}">
              <div class="d-block text-center pt-5">
                Total Market Value
              </div>
              <v-card-text class="mt-5 text-center headline">
                $ {{ investorData.market_value | numeral('0.00a') }}
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card height="150" :class="{'mr-3 card-width': $vuetify.breakpoint.mdAndUp}">
              <div class="d-block text-center pt-5">
                Turnover
              </div>
              <v-card-text class="mt-5 text-center headline">
                {{ Number((investorData.turnover * 100).toFixed(1)) }}%
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card height="150" :class="{'mr-3 card-width': $vuetify.breakpoint.mdAndUp}">
              <div class="d-block text-center pt-5">
                No of Holdings
              </div>
              <v-card-text class="mt-5 text-center headline">
                {{ investorData.nb_holdings }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" >
        <v-card v-if="insightsLoad">
          <v-skeleton-loader type="card" height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>          
        </v-card>
        <v-card v-if="!insightsLoad">
          <v-card-title>
            <v-icon left large style="color:#f732df;">mdi-chart-timeline-variant</v-icon>
            <span id="insights">Insights</span>
          </v-card-title>
          <v-card-text>
              <v-expansion-panels accordion multiple hover>
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">                    
                    <v-row  no-gutters>                      
                      <v-col cols="4">Classification and Performance</v-col>
                    <v-col
                      cols="8"
                      class="text--secondary"
                    >
                    <v-fade-transition leave-absolute> 
                      <span
                        v-if="open"
                        key="0"
                      >
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                      {{investorInsights && investorInsights.performance.insights.perf_short}}
                      </span>
                    </v-fade-transition>
                    </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters v-if="investorInsights">
                      <v-col cols="12" md="12" v-if="investorInsights.performance.insights.style">
                        {{investorInsights.performance.insights.style}} <v-btn text small  @click="$vuetify.goTo('#style')" color="primary">+</v-btn> <br>
                      </v-col>
                      <v-col cols="12" md="12" v-if="investorInsights.performance.insights.perf">
                        {{investorInsights.performance.insights.perf}}<v-btn text small  @click="$vuetify.goTo('#performance')" color="primary">+</v-btn><br>
                      </v-col>
                      <v-col cols="12" md="12" v-if="investorInsights.performance.insights.stocks">
                        {{investorInsights.performance.insights.stocks.text}}
                        
                        <span v-for="(item, index) in investorInsights.performance.insights.stocks.stocks" :key="item.id">
                          <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                :color="getColorBasedOnPerf(item.contrib)"
                                text
                                small 
                                v-bind="attrs"
                                v-on="on"                                
                              >
                                {{item.name}} {{item.text}}
                              </v-btn>
                            </template>
                            <v-list>
                              <v-subheader>{{item.name}}</v-subheader>
                              <v-list-item>
                                <v-list-item-title>    
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn icon color="primary" v-on="on" :to="'/stocks/analyze/' + item.id"  >
                                        <v-icon >mdi-magnify-plus-outline</v-icon>
                                      </v-btn>     
                                      Go to stock page
                                    </template>                      
                                    <span>Analyze</span>
                                  </v-tooltip>                                   
                                  </v-list-item-title>
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-title><stock-set-preference :stock="item.id" :rating="item.preference"></stock-set-preference>Rate the stock</v-list-item-title>                      
                              </v-list-item>
                              <v-list-item>
                                <v-list-item-title><stock-potential-replacement :stock="item.id" :title="item.name"></stock-potential-replacement>Check similar stocks</v-list-item-title>
                              </v-list-item>                              
                            </v-list>
                          </v-menu>  

                          <span v-if="index < investorInsights.performance.insights.stocks.stocks.length - 2">,</span>
                          <span v-if="index === investorInsights.performance.insights.stocks.stocks.length -2">and</span>

                        </span>
   
                      </v-col>                      
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>             
                <v-expansion-panel>
                  <v-expansion-panel-header v-slot="{ open }">                    
                    <v-row  no-gutters>                      
                      <v-col cols="4">Volume</v-col>
                    <v-col
                      cols="8"
                      class="text--secondary"
                    >
                    <v-fade-transition leave-absolute> 
                      <span
                        v-if="open"
                        key="0"
                      >
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                      {{investorInsights && investorInsights.performance.insights.volume_short}}
                      </span>
                    </v-fade-transition>
                    </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters v-if="investorInsights">
                      <v-col cols="12" md="12" v-if="investorInsights.performance.insights.volume">
                        {{investorInsights.performance.insights.volume}} <v-btn text small  @click="$vuetify.goTo('#style')" color="primary">+</v-btn> <br>
                      </v-col>                    
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel :disabled="investorInsights.expo.insights.length===0 | investorInsights.expo.insights===null">
                  <v-expansion-panel-header v-slot="{ open }">                    
                    <v-row  no-gutters>                      
                      <v-col cols="4">Investor Exposure</v-col>
                    <v-col
                      cols="8"
                      class="text--secondary"
                    >
                    <v-fade-transition leave-absolute> 
                      <span
                        v-if="open"
                        key="0"
                      >
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                      {{investorInsightsSummary}}
                      </span>
                    </v-fade-transition>
                    </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row no-gutters v-if="investorInsights && investorInsights.expo">
                      <v-col cols="12" md="12" v-if="investorInsights.expo.insights">
                        <ul v-for="item in investorInsights.expo.insights" :key="item.name">
                          <li>{{item.name}} : {{item.general}} {{item.investor}}
                            <expo-distribution :title="item.name + ' Distribution'" :expo="item.id" :type="item.type" :investor="investor"></expo-distribution> <v-btn text small  @click="$vuetify.goTo('#expo')" color="primary">+</v-btn>
                          </li>
                        </ul>
                      </v-col>                    
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel :disabled="investorInsights.sim.insights.length===0 | investorInsights.sim.insights===null">
                  <v-expansion-panel-header v-slot="{ open }">                    
                    <v-row  no-gutters>                      
                      <v-col cols="4">Similarities with you</v-col>
                    <v-col
                      cols="8"
                      class="text--secondary"
                    >
                    <v-fade-transition leave-absolute> 
                      <span
                        v-if="open"
                        key="0"
                      >
                      </span>
                      <span
                        v-else
                        key="1"
                      >
                      {{investorInsights.sim.summary}}
                      </span>
                    </v-fade-transition>
                    </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content >
                    <v-row no-gutters v-if="investorInsights && investorInsights.sim">
                      <v-col cols="12" md="12" v-if="investorInsights.sim.insights">
                        <ul v-for="item in investorInsights.sim.insights" :key="item.name">
                          <li>{{item.id}} : {{item.text}} </li>
                        </ul>
                      </v-col>                    
                    </v-row>                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
             </v-expansion-panels>    

            <!--<v-row no-gutters v-if="investorInsights">
               <v-col cols="12" md="12" v-if="investorInsights.performance">
                <b>Performance Insights</b>
                <ul>                
                  <li v-if="investorInsights.performance.style">{{investorInsights.performance.style}} <v-btn text small  @click="$vuetify.goTo('#style')" color="primary">+</v-btn></li>
                  <li v-if="investorInsights.performance.perf">{{investorInsights.performance.perf}}<v-btn text small  @click="$vuetify.goTo('#performance')" color="primary">+</v-btn></li >
                  <li  v-if="investorInsights.performance.volume">{{investorInsights.performance.volume}}<v-btn text small  @click="$vuetify.goTo('#volume')" color="primary">+</v-btn> </li>   
                </ul>               
              </v-col> -->
              <!-- <v-col cols="12" md="12" v-if="investorInsights.insights.style">
                {{investorInsights.insights.style}} <v-btn text small  @click="$vuetify.goTo('#style')" color="primary">+</v-btn> <br>
              </v-col>
              <v-col cols="12" md="12" v-if="investorInsights.insights.perf">
                {{investorInsights.insights.perf}}<v-btn text small  @click="$vuetify.goTo('#performance')" color="primary">+</v-btn><br>
              </v-col>
              <v-col cols="12" md="12" v-if="investorInsights.insights.volume">
                {{investorInsights.insights.volume}}<v-btn text small  @click="$vuetify.goTo('#volume')" color="primary">+</v-btn> <br>         
              </v-col>           -->
            <!-- </v-row>     
             <v-row no-gutters v-if="investorInsights">
                <v-col cols="12" md="12" v-if="investorInsights.expo !=''">
                  <b>Expo Insights</b> <v-btn text small  @click="$vuetify.goTo('#expo')" color="primary">+</v-btn>
                  <ul v-for="item in investorInsights.expo" :key="item.id">
                    <li>{{item.name}} : {{item.general}} {{item.investor}}
                      <expo-distribution :title="item.name + ' Distribution'" :expo="item.id" :type="item.type" :investor="investor"></expo-distribution>
                    </li>
                  </ul>
                </v-col>
            </v-row>   
            <v-row no-gutters v-else>
                <v-col cols="12" md="12" >
                  <v-skeleton-loader type="card"  height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
                </v-col>                          
              </v-row>          -->                               
          </v-card-text>          
        </v-card>
      </v-col>

    </v-row>

    <investor-analyze-component-similar-investors :investor="investor"/>

    <investor-analyze-component-chart-performance  :investor="investor"/>

    <investor-analyze-component-styles :investor="investor" id="style"/>

    <investor-analyze-component-chart-volume :investor="investor"/>

    <investor-analyze-component-might-like :investor="investor"/>

    <investor-analyze-component-might-avoid :investor="investor"/>

    <v-row class="my-2">
      <v-col cols="12" md="6">
        <investor-analyze-component-sector-expo id="expo" :investor="investor"/>
      </v-col>
      <v-col cols="12" md="6">
        <investor-analyze-component-country-expo :investor="investor"/>
      </v-col>
    </v-row>

    <investor-analyze-component-portfolio :investor="investor"/>

    <v-dialog v-model="readmoreDialog" max-width="600px">
      <v-card class="px-7" style="background: #121212;">
        <v-container>
          <v-row>
            <v-col cols="9">
              <p>
                <span
                  class="font-weight-bold"
                  style="font-size: 20px"
                >
                  {{ investorData.name }}
                </span>
              </p>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-icon size="50" style="color:#f732df;">mdi-text-box-multiple-outline</v-icon>
            </v-col>
            <v-col cols="12">
              <p>
                {{ investorData.description }}
              </p>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="readmoreDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fundlistDialog" max-width="600px">
      <v-card class="px-7" style="background: #121212;">
        <v-container>
          <v-row>
            <v-col cols="9">
              <p>
                <span
                  class="font-weight-bold"
                  style="font-size: 20px"
                >
                  List of funds for {{ investorData.name }}
                </span>
              </p>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-icon size="50" style="color:#f732df;">mdi-text-box-multiple-outline</v-icon>
            </v-col>
            <v-col cols="12">
            <v-simple-table v-if="!listLoad">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left"></th>
                    <th class="text-left">Fund Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in investorData.list_funds" :key="i">
                  <td>
                    <v-btn
                      class="px-2 mr-2"
                      color="primary"
                      min-width="0"
                      icon
                      small
                      @click="goToInvestor(item.fund_id)"
                    >
                      <v-icon>
                        mdi-magnify-plus-outline
                      </v-icon>
                    </v-btn>
                  </td>                         
                    <td>{{ item.name }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>              
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="fundlistDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="errorbar"
    >
      An error has occurred/No data found
      <v-btn
        color="pink"
        text
        @click="errorbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>    
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { mapMutations } from 'vuex'
  //import RadialProgressBar from 'vue-radial-progress'
  import { algoReadyTourSteps } from '@/utils/constants'  
  export default {
    name: 'investorsAnalyze',
    props:['investor'],
    components: {
      //InvestorAnalyzeComponentInsights: () => import('../components/investors/analyze/Insights'),
      InvestorAnalyzeComponentSimilarInvestors: () => import('../components/investors/analyze/SimilarInvestors'),
      InvestorAnalyzeComponentChartPerformance: () => import('../components/investors/analyze/ChartPerformance'),
      InvestorAnalyzeComponentStyles: () => import('../components/investors/analyze/Styles'),
      InvestorAnalyzeComponentChartVolume: () => import('../components/investors/analyze/ChartVolume'),
      InvestorAnalyzeComponentMightLike: () => import('../components/investors/analyze/MightLike'),
      InvestorAnalyzeComponentMightAvoid: () => import('../components/investors/analyze/MightAvoid'),
      InvestorAnalyzeComponentSectorExpo: () => import('../components/investors/analyze/SectorExpo'),
      InvestorAnalyzeComponentCountryExpo: () => import('../components/investors/analyze/CountryExpo'),
      InvestorAnalyzeComponentPortfolio: () => import('../components/investors/analyze/Portfolio'),
      //RadialProgressBar,
      ExpoDistribution: () => import('@/views/dashboard/components/investors/analyze/ExpoDistribution'),      

      StockPotentialReplacement: () => import('@/components/StockPotentialReplacement'),
      StockSetPreference: () => import('@/components/SetPreferences'),      
    },
    data() {
      return {
        readmoreDialog: false,
        fundlistDialog: false,
        investorData: {},
        investorInsights: null,
        investorInsightsSummary:null,
        listLoad: true,
        insightsLoad: true,
        errorbar: false,         
      }
    },
    mounted () {
      this.getDataFromApi()
      this.getInsightsFromApi()
      this.activateTour(algoReadyTourSteps.inverstorAnalyze)
    },
    destroyed () {
      this.deactivateTour()
    },    
    methods: {
      ...mapMutations({
        activateTour: 'ACTIVATE_ALGO_READY_TOUR',
        deactivateTour: 'DEACTIVATE_ALGO_READY_TOUR',
      }),      
      formatDate(value) {
        return moment(String(value)).format("YYYY-MM-DD")
      },
      goToInvestor(id) {
        this.$router.push({ name: 'InvestorsAnalyze', params: { investor: id } });
      },
      getColorBasedOnPerf(contrib) {
        if (contrib>0) {
          return "primary"
        } else {
          return "#e9507f"
        }
      },      
      async getDataFromApi () {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-investor-insights/' + self.investor,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.investorData = response.data
          self.listLoad = false
        }).catch(function () {
          //self.listLoad = false
          self.errorbar = true
        })
      },
      async getInsightsFromApi () {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.post(process.env.VUE_APP_API_HOST + '/get-investor-insights-text/' + self.investor,{},{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.investorInsights = response.data
          self.investorInsightsSummary = response.data && response.data.expo.summary
          self.insightsLoad = false
        }).catch(function () {
          //self.insightsLoad = false
          self.errorbar = true
        })
      },      
    },
  }
</script>

<style scoped lang="sass">
  .card-width
    width: 200px
</style>